import { useEffect } from 'react'

import AOS from 'aos'
import 'aos/dist/aos.css'

interface CaseImageProps {
 imageIndex: number
 add?: string
 folder: string
 image: string
}

export function CaseImage({ imageIndex, add, folder, image }: CaseImageProps) {
 const folderName = folder
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim()
  .replace(/\s+/g, '-')
  .replace(/[^a-z0-9\-]/g, '')

 useEffect(() => {
  AOS.init()
 }, [])

 return (
  <img
   src={`https://www.admancriativa.com.br/assets/img/cases/full/${folderName}/${image}`}
   alt={`Imagem ${imageIndex + 1}`}
   width={1200}
   height={600}
   sizes="(min-width: 992px) 66.66vw, (min-width: 768px) 33.33vw, 100vw"
   className={`w-full h-auto object-cover ${add}`}
  />
 )
}
